import * as mixpanelBrowser from 'mixpanel-browser';
import { useEffect, useMemo } from 'react';
import { useGetConsents } from 'api';
import { useSession } from 'context';
import { usePlatform } from 'hooks';
import { environment } from 'utils/environmentVariables';

const MIXPANEL_TOKEN = environment.REACT_APP_MIXPANEL_TOKEN;
const MIXPANEL_CONFIG: Partial<mixpanelBrowser.Config> = {
  api_host: 'https://api-eu.mixpanel.com',
  track_pageview: false,
  ignore_dnt: true,
  opt_out_tracking_by_default: false,
  debug: false,
  ip: false,
};

export const useMixpanelTracking = (token = MIXPANEL_TOKEN) => {
  const mixpanel = useMemo(() => {
    if (!token) {
      return undefined;
    }
    return mixpanelBrowser.init(
      token,
      MIXPANEL_CONFIG,
      'global-app-mixpanel-instance'
    );
  }, [token]);

  const { platform } = usePlatform();
  const session = useSession();
  const { data } = useGetConsents(!!session);

  useEffect(() => {
    if (data && mixpanel) {
      if (!data.userConsents['DATA_ANALYSIS']) {
        mixpanel.opt_out_tracking();
      } else if (!mixpanel.has_opted_in_tracking()) {
        mixpanel.opt_in_tracking();
      }
    }
  }, [data, mixpanel]);

  const trackEvent = (
    distinctId: string,
    event: string,
    properties?: object
  ) => {
    if (mixpanel) {
      try {
        mixpanel.track(event, {
          ...properties,
          platform: platform,
          distinct_id: distinctId,
          $insert_id: distinctId,
        });
      } catch (error) {
        console.error('Mixpanel tracking error:', error);
      }
    }
  };

  return trackEvent;
};
